module.exports = __webpack_public_path__ + "img/nissan-service.cc963fd6.png";